export class GetPostError extends Error {
  public constructor(errorCode?: string) {
    super()

    this.message = errorCode ? `errors.getPost.${errorCode}` : 'errors.getPost.general'
  }
}
